import { ContentContainer } from 'themes/canvas/components/ContentContainer';

import { TPortfolioImage } from 'types/portfolio';

import { ImageWithText } from '../ImageWithText';

import s from './CanvasAboutSection.module.css';

export interface AboutProps {
  className?: string;
  about: string;
  image: TPortfolioImage | undefined;
  loading: boolean;
  showPortfolio: boolean;
}

export const CanvasAboutSection = ({
  about,
  image,
  showPortfolio,
}: AboutProps) => {
  const hasAboutText = about?.length > 0;

  if (!hasAboutText) {
    return null;
  }

  return (
    <section className={s.root}>
      <ContentContainer className={s.content}>
        <ImageWithText
          heading="ABOUT US"
          content={about}
          image={image}
          showPortfolio={showPortfolio}
        />
      </ContentContainer>
    </section>
  );
};
